var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { noop } from 'ts-essentials';
import { api } from 'utils/apis/api';
export const billingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readPaymentInformation: builder.query({
            query: () => ({
                version: 1,
                path: 'billing/paymentinformation',
            }),
        }),
        updatePaymentInformation: builder.mutation({
            query: ({ patch: body }) => ({
                version: 1,
                method: 'PATCH',
                path: 'billing/paymentinformation',
                body,
            }),
            onQueryStarted({ patch }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const { data } = yield queryFulfilled;
                        if (Object.keys(data.data.update_errors).length !== 0) {
                            return;
                        }
                        dispatch(billingApi.util.updateQueryData('readPaymentInformation', undefined, (draft) => {
                            var _a, _b;
                            const mutableDraft = draft;
                            for (const [key, value] of Object.entries((_a = patch.updates) !== null && _a !== void 0 ? _a : {})) {
                                mutableDraft.data.payment_information[key] = value;
                            }
                            (_b = patch.deletes) === null || _b === void 0 ? void 0 : _b.forEach((key) => {
                                mutableDraft.data.payment_information[key] = '';
                            });
                        }));
                    }
                    catch (_a) {
                        noop();
                    }
                });
            },
        }),
        readValidateVatNumber: builder.query({
            query: ({ vatNumber }) => ({
                version: 1,
                path: `billing/paymentinformation/vatin/${vatNumber}/validate`,
            }),
        }),
        readPaymentMethods: builder.query({
            query: () => ({
                version: 1,
                path: 'billing/paymentmethod',
            }),
        }),
        updateDefaultPaymentMethod: builder.mutation({
            query: ({ id }) => ({
                version: 1,
                method: 'PUT',
                path: `billing/paymentmethod/${id}/default`,
            }),
        }),
        deletePaymentMethod: builder.mutation({
            query: ({ id }) => ({
                version: 1,
                method: 'DELETE',
                path: `billing/paymentmethod/${id}`,
            }),
            onQueryStarted({ id }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchReadPaymentMethods = dispatch(billingApi.util.updateQueryData('readPaymentMethods', undefined, (draft) => {
                        const mutablePaymentMethods = draft.data
                            .payment_methods;
                        const index = draft.data.payment_methods.findIndex((_paymentMethod) => _paymentMethod.id === id);
                        if (index !== -1) {
                            mutablePaymentMethods.splice(index, 1);
                        }
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchReadPaymentMethods.undo();
                    }
                });
            },
        }),
        createCreditCard: builder.mutation({
            query: ({ token }) => ({
                version: 1,
                method: 'POST',
                path: 'billing/creditcard',
                body: { token },
            }),
        }),
        readInvoices: builder.query({
            query: () => ({
                version: 1,
                path: 'billing/invoices',
            }),
        }),
        readInvoice: builder.query({
            query: ({ id }) => ({
                version: 1,
                path: `billing/invoices/${id}/pdf`,
            }),
        }),
        createSetupIntent: builder.mutation({
            query: () => ({
                version: 1,
                path: `billing/setupintent`,
                method: 'POST',
            }),
        }),
    }),
});
